import React from 'react';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
import { URGENCY_LABELS, URGENCY_COLORS, URGENCY } from './constants';

const useStyles = makeStyles(() => ({
  badge: {
    fontWeight: 600,
    fontSize: '0.72rem',
    height: 22,
    borderRadius: 11,
    color: '#fff',
  },
  emergencyFlash: {
    animation: '$flash 1s ease-in-out infinite',
  },
  '@keyframes flash': {
    '0%': { opacity: 1 },
    '50%': { opacity: 0.5 },
    '100%': { opacity: 1 },
  },
}));

const UrgencyBadge = ({ urgency, size = 'small', className = '' }) => {
  const classes = useStyles();
  const label = URGENCY_LABELS[urgency] || urgency;
  const bgColor = URGENCY_COLORS[urgency] || '#9E9E9E';
  const isEmergency = urgency === URGENCY.EMERGENCY;

  return (
    <Chip
      label={label}
      size={size}
      className={`${classes.badge} ${isEmergency ? classes.emergencyFlash : ''} ${className}`}
      style={{ backgroundColor: bgColor }}
    />
  );
};

export default UrgencyBadge;
